export const API_ENDPOINTS = {
  roles: 'adm/api/product-roles',
  role: 'api/authorization/role',
  createRole: '/api/authorization/create-role',
  duplicateRole: '/api/authorization/duplicate-role',
  assignRole: '/api/authorization/assign-role',
  assignRoleBulk: '/api/authorization/assign-role-bulk',
  unAssignRole: '/api/authorization/remove-role',
  applicationRoles: '/api/authorization/application-roles/customer-admin',
  applicationRolesForCustomer: '/api/authorization/customer-allowed-roles',
  subjects: '/api/authorization/subjects',
  permissions: '/api/authorization-outside',
  synchronizeRole: '/api/authorization/call-role-synchronize',
  rolesForSync: '/api/get-roles-to-synchronize',
};

export const MODAL_TYPES = Object.freeze({
  CREATE: 'Create',
  DELETE: 'Delete',
  UPDATE: 'Update',
} as const);

export type TModalType = typeof MODAL_TYPES[keyof typeof MODAL_TYPES];
